import { type UseQueryOptions, useQuery } from "@tanstack/react-query"
import type { TUser } from "@/types/common"
import { fetchAPISlackTeamUsers } from "@/utils"

export default function useSlackImportTeam(params: Omit<UseQueryOptions<TUser[]>, "queryKey"> = {}) {
  return useQuery<TUser[]>({
    queryKey: ["slack-import-users"],
    queryFn: fetchAPISlackTeamUsers,
    ...params,
  })
}
